import axios from "axios";
import { BASE_URL } from "../../variables";


export const getBudgetMaxCost = async (clusterCode) => {
  try {
    const query = `SELECT Id, Type_of_DRM__c, Max_Cost__c FROM Budget_Management__c WHERE City_Type_Id__c='${clusterCode}'`;

    const url = `${BASE_URL}/services/data/v61.0/query/?q=${query}`;


    const options = {
        url,
        method: "get",
      };
      

    const response = await axios(options);
    return response.data.records;
  } catch (error) {
    console.error("Error fetching Budget Management data:", error);
    throw error;
  }
};
